// extracted by mini-css-extract-plugin
export default {"widget_header":"calendar-widget_widget_header__vlpht","title":"calendar-widget_title__op9ns"};